import { BLOG_CONTENT_API } from '@/constants'
import { replaceString } from '@/utils/replaceString'

type Result = {
  notFound: boolean
  title: string
  html: string
  description: string
  shouldIndex: boolean
}

/**
 * Serverless function to fetch any Ghost CMS page from /education
 */
export async function fetchEducationPage(slug: string): Promise<Result> {
  let page: any = {}
  let hasNoRobotTag = false
  let notFound = false
  try {
    const resource = (path: string) => {
      return replaceString(BLOG_CONTENT_API, {
        key: 'resource',
        value: path,
      })
    }

    const path = `/content/pages/slug/${slug}`
    const res = await fetch(`${resource(path)}`, {})
    const content = await res.json()
    page = content?.pages?.length > 0 ? content?.pages[0] : null
    hasNoRobotTag = page?.tags?.some((tag) => tag.slug === 'hash-norobot')

    if (!res.ok) {
      if (res.status === 404) {
        notFound = true
      }
    }
  } catch (e) {
    console.error(JSON.stringify(e))
  }

  return {
    notFound,
    title: page?.title || '',
    html: page?.html || '',
    description: page?.custom_excerpt || '',
    shouldIndex: !hasNoRobotTag,
  }
}
